import React from "react";
import { Dialog, Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { RootState } from "../../store/Index";
import { setSessionExpired } from "../../store/slice/AuthSlice";

const SessionExpiredModal: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const open = useSelector((state: RootState) => state.auth.sessionExpired);

  const handleSignInAgain = () => {
    dispatch(setSessionExpired(false));
    navigate(
      `/login?redirect=${encodeURIComponent(
        location.pathname + location.search,
      )}`,
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleSignInAgain}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            mb: 1.5,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            You have been signed out
          </Typography>
          <IconButton
            size="small"
            onClick={handleSignInAgain}
            sx={{ mt: -0.5, mr: -1 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Your session has expired. Please sign in again to continue.
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleSignInAgain}
            sx={{ textTransform: "none", fontWeight: 600, borderRadius: 999 }}
          >
            Sign in again
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SessionExpiredModal;
